import React, { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Trash2, X } from 'lucide-react'
import { tr } from 'i18n'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import s from '../Management.module.scss'

type Props = { name: string; busy: boolean; error: string; onClose: () => void; onConfirm: (pin: string) => void }

export default function BranchDeleteDialog({ name, busy, error, onClose, onConfirm }: Props) {
  useTranslation()
  const [pin, setPin] = useState('')
  const titleId = useId()
  const valid = /^[0-9]{4}$/.test(pin)
  return <div className={s.overlay}>
    <form className={s.dialog} role="dialog" aria-modal="true" aria-labelledby={titleId}
      onSubmit={event => { event.preventDefault(); if (valid && !busy) onConfirm(pin) }}>
      <h2 id={titleId}><Trash2 size={20} aria-hidden="true" />{tr('Удаление филиала')}</h2>
      <p>{name}</p>
      <p>{tr('Филиал будет удалён. Подтвердите действие своим PIN.')}</p>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      <ActorPinField value={pin} onChange={setPin} disabled={busy} hint={tr('Введите PIN своей учётной записи.')} />
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button className={s.danger} disabled={busy || !valid}>{busy ? tr('Удаление…') : tr('Удалить филиал')}</button>
      </div>
    </form>
  </div>
}
